import {
  GET_MY_REQUESTS,
  GET_MY_REQUESTS_FULFILLED,
  GET_MY_REQUESTS_REJECTED,
  SET_COLABORATOR_APPEAL,
  SET_COLABORATOR_APPEAL_FULFILLED,
  SET_COLABORATOR_APPEAL_REJECTED,
  MODIFY_REQUEST_STATUS,
  MODIFY_REQUEST_STATUS_FULFILLED,
  MODIFY_REQUEST_STATUS_REJECTED,
} from "./actionTypes";
import { requestsIds } from "@icarius-utils/requestsIds";

const initialState = {
  recipients: {},
  myRequests: [],
  gettingMyRequests: false,
  raiseCalculationData: {},
  fireCalculationData: {},
  colaborators: [],
  decimalSeparator: null,
  currencyLocalization: null,
  dateFormat: null,
  settingRequest: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_MY_REQUESTS:
      return { ...state, gettingMyRequests: true };
    case GET_MY_REQUESTS_REJECTED:
      return { ...state, gettingMyRequests: false };
    case GET_MY_REQUESTS_FULFILLED:
      return {
        ...state,
        gettingMyRequests: false,
        recipients: action.payload.recipients,
        myRequests: action.payload.myRequests,
        raiseCalculationData: action.payload.raiseCalculationData,
        fireCalculationData: action.payload.fireCalculationData,
        colaborators: action.payload.colaborators,        
        decimalSeparator: action.payload.decimalSeparator,
        currencyLocalization: action.payload.currencyLocalization,
        dateFormat: action.payload.dateFormat,
      };

    case SET_COLABORATOR_APPEAL:
      return { ...state, settingRequest: true };
    case SET_COLABORATOR_APPEAL_FULFILLED: {
      let auxVacation = state.vacationCalculationData;
      let auxPermission = state.permissionCalculationData;
      let auxAdvance = state.advanceCalculationData;

      switch (action.payload.type) {
        case requestsIds.holidays:
          auxVacation.can_user_appeal = false;
          break;
        case requestsIds.permission:
          auxPermission.can_user_appeal = false;
          break;
        case requestsIds.advance:
          auxAdvance.can_user_appeal = false;
          break;
        default: break;
      }
      

      let newArray = state.myRequests.length > 0 ? [...state.myRequests] : [];
      if(!action.payload.includesHistory){
        newArray.unshift(action.payload.data);
      }

      return { ...state, usedDates: action.payload.usedDates || state.usedDates, settingRequest: false, vacationCalculationData: auxVacation, permissionCalculationData: auxPermission, advanceCalculationData: auxAdvance, myRequests: newArray };
    }
    case SET_COLABORATOR_APPEAL_REJECTED:
      return { ...state, settingRequest: false };


    case MODIFY_REQUEST_STATUS:
      return { ...state, settingRequest: true };
    case MODIFY_REQUEST_STATUS_FULFILLED:
      let newArray = [...state.myRequests];
      if(action.payload.shouldRemoveFromArray){
        newArray = state.myRequests.filter(request => request.code !== action.payload.data.code);
      }

      let auxVacation = state.vacationCalculationData;
      let auxPermission = state.permissionCalculationData;
      let auxAdvance = state.advanceCalculationData;

      switch (action.payload.type) {
        case requestsIds.holidays:
          auxVacation.can_user_appeal = action.payload.canUserAppeal;
          break;
        case requestsIds.permission:
          auxPermission.can_user_appeal = action.payload.canUserAppeal;
          break;
        case requestsIds.advance:
          auxAdvance.can_user_appeal = action.payload.canUserAppeal;
          break;

        default: break;
      }
      return { ...state, usedDates: action.payload.usedDates || state.usedDates, settingRequest: false, myRequests: newArray, vacationCalculationData: auxVacation, permissionCalculationData: auxPermission, advanceCalculationData: auxAdvance };
    case MODIFY_REQUEST_STATUS_REJECTED:
      return { ...state, settingRequest: true };

    default:
      return state;
  }
}
